import { useCallback, useMemo } from "react";
import moment from "moment-timezone";
// styles
import styles from "./ScheduleIntervalTimeslot.module.scss";
// types
import type { TScheduleIntervalTimeSlot } from "../../types";
// hooks
import { useCalendarTime } from "components/Dashboard/DoctorDashboard/views/one-one-sessions/contexts/CalendarTimeContext";
// utils
import { getIsPastHours } from "utils/getIsPastHours";
import getClasses from "utils/getClasses";

const ScheduleIntervalTimeslot = ({
  scheduleInterval,
  date,
  isToday,
}: {
  scheduleInterval: NonNullable<TScheduleIntervalTimeSlot>;
  date: Date;
  isToday: boolean;
}) => {
  const { currentCalendarTimezone } = useCalendarTime();
  const {
    duration: [start, end],
  } = scheduleInterval;

  const { isPastHours } = useMemo(() => {
    const start = moment(+date).tz(currentCalendarTimezone);
    start.hours(scheduleInterval.startHour);
    const startValue = start.valueOf();
    return { isPastHours: getIsPastHours(startValue) };
  }, [currentCalendarTimezone, date, scheduleInterval.startHour]);

  const onClick = useCallback((event) => {
    event.stopPropagation();
    event.preventDefault();
  }, []);
  return (
    <button
      className={getClasses(
        styles["schedule-interval-timeslot"],
        isToday && styles["schedule-interval-timeslot--active"],
      )}
      style={{
        pointerEvents: isPastHours ? "none" : "unset",
        /**
         * based on mins percentage in the hour
         * @example 2:18 -> 18 / 60 -> 30%
         */
        top: `${(+start / 60) * 100}%`,
        height: `${((end - start) / 60) * 100}%`,
      }}
      onClick={onClick}
    />
  );
};

export default ScheduleIntervalTimeslot;
